import { Link } from "react-router-dom";
import { useTheme } from "@/context/ThemeContext";

export default function Logo({ className = "", to = "/", size = "md" }) {
  const { theme } = useTheme();
  const h = size === "sm" ? "h-12" : size === "lg" ? "h-24" : "h-16";
  const src = theme === "dark" ? "/vulpix-logo-dark.png" : "/vulpix-logo-light.png";
  const inner = (
    <img
      src={src}
      alt="VULPIX"
      className={`${h} w-auto object-contain`}
      data-testid="vulpix-logo"
    />
  );
  if (!to) return <div className={className}>{inner}</div>;
  return (
    <Link to={to} className={`inline-flex items-center ${className}`} data-testid="logo-link">
      {inner}
    </Link>
  );
}
